import { Tag, TagVariant } from '@polyai/ui/components/atoms/Tag';

import { TRIAL_BANNER_COPY } from '../Banner.uiCopy';

interface BannerTagProps {
  daysLeft: number;
  pluralisedDay: string;
}

const BannerTag = ({ daysLeft, pluralisedDay }: BannerTagProps) => {
  const isWarning = daysLeft <= 5;

  return (
    <Tag
      variant={isWarning ? TagVariant.YELLOW : TagVariant.BLACK}
      className="!px-xs2 !py-xxs2 !h-auto border border-border-strong-inverse flex-none"
      textClassName="!leading-[1]"
    >
      {TRIAL_BANNER_COPY.tag.daysLeft(daysLeft, pluralisedDay)}
    </Tag>
  );
};

export default BannerTag;
